import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
export const TermsPage = () => {
  return <div className="min-h-screen bg-black text-white" data-id="element-461">
      <SEO title="Algemene Voorwaarden - Blue Rain Productions" description="De algemene voorwaarden van Blue Rain Productions. Lees de voorwaarden die van toepassing zijn op onze diensten en samenwerkingen." data-id="element-462" />
      <Navbar data-id="element-463" />
      <main data-id="element-464">
        <section className="py-32 bg-gradient-to-b from-black to-gray-950 w-full" data-id="element-465">
          <div className="container mx-auto px-4 md:px-6" data-id="element-466">
            <h1 className="text-4xl md:text-6xl font-bold mb-8 text-center" data-id="element-467">
              Algemene Voorwaarden
            </h1>
            <div className="max-w-4xl mx-auto mt-12 mb-16" data-id="element-468">
              <div className="prose prose-invert prose-lg" data-id="element-469">
                <p className="text-gray-300 mb-6" data-id="element-470">
                  Deze algemene voorwaarden zijn van toepassing op alle
                  overeenkomsten tussen Blue Rain Productions en haar klanten.
                  Door gebruik te maken van onze diensten gaat u akkoord met
                  deze voorwaarden.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-471">
                  1. Definities
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-472">
                  In deze algemene voorwaarden wordt verstaan onder:
                </p>
                <ul className="list-disc pl-6 text-gray-300 space-y-2 mb-6" data-id="element-473">
                  <li data-id="element-474">
                    <strong data-id="element-475">Blue Rain Productions:</strong> gevestigd te
                    Nederland, ingeschreven bij de Kamer van Koophandel onder
                    nummer 93937369.
                  </li>
                  <li data-id="element-476">
                    <strong data-id="element-477">Klant:</strong> de natuurlijke persoon of
                    rechtspersoon die met Blue Rain Productions een overeenkomst
                    aangaat.
                  </li>
                  <li data-id="element-478">
                    <strong data-id="element-479">Diensten:</strong> alle werkzaamheden die Blue Rain
                    Productions voor een klant verricht, waaronder productie,
                    locatiemanagement, setmanagement en locatiescout.
                  </li>
                  <li data-id="element-480">
                    <strong data-id="element-481">Overeenkomst:</strong> elke afspraak tussen Blue
                    Rain Productions en de klant tot het verlenen van diensten.
                  </li>
                </ul>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-482">
                  2. Toepasselijkheid
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-483">
                  Deze algemene voorwaarden zijn van toepassing op alle
                  aanbiedingen, offertes en overeenkomsten tussen Blue Rain
                  Productions en de klant, tenzij uitdrukkelijk schriftelijk
                  anders is overeengekomen.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-484">
                  3. Offertes en aanbiedingen
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-485">
                  Alle offertes en aanbiedingen van Blue Rain Productions zijn
                  vrijblijvend, tenzij in de offerte een termijn voor
                  aanvaarding is gesteld. Een offerte of aanbieding vervalt
                  indien het product waarop de offerte of de aanbieding
                  betrekking heeft in de tussentijd niet meer beschikbaar is.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-486">
                  4. Uitvoering van de overeenkomst
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-487">
                  Blue Rain Productions zal de overeenkomst naar beste inzicht
                  en vermogen en overeenkomstig de eisen van goed vakmanschap
                  uitvoeren. Blue Rain Productions heeft het recht bepaalde
                  werkzaamheden te laten verrichten door derden.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-488">
                  5. Wijziging van de overeenkomst
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-489">
                  Indien tijdens de uitvoering van de overeenkomst blijkt dat
                  het voor een behoorlijke uitvoering daarvan noodzakelijk is om
                  deze te wijzigen of aan te vullen, zullen partijen tijdig en
                  in onderling overleg tot aanpassing van de overeenkomst
                  overgaan.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-490">
                  6. Honorarium en kosten
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-491">
                  Het honorarium van Blue Rain Productions is exclusief BTW en
                  andere heffingen van overheidswege, eventuele in het kader van
                  de overeenkomst te maken kosten, daaronder begrepen reis- en
                  verblijf-, verzend- en administratiekosten, tenzij anders
                  aangegeven.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-492">
                  7. Betaling en incassokosten
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-493">
                  Betaling dient te geschieden binnen 14 dagen na factuurdatum,
                  op een door Blue Rain Productions aan te geven wijze. Bezwaren
                  tegen de hoogte van een factuur schorten de
                  betalingsverplichting niet op.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-494">
                  8. Aansprakelijkheid
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-495">
                  Blue Rain Productions is niet aansprakelijk voor schade, van
                  welke aard ook, ontstaan doordat Blue Rain Productions is
                  uitgegaan van door of namens de klant verstrekte onjuiste
                  en/of onvolledige gegevens.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-496">
                  9. Intellectuele eigendom
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-497">
                  Blue Rain Productions behoudt zich de rechten en bevoegdheden
                  voor die hem toekomen op grond van de Auteurswet en andere
                  intellectuele wet- en regelgeving.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-498">
                  10. Toepasselijk recht en geschillen
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-499">
                  Op alle rechtsbetrekkingen waarbij Blue Rain Productions
                  partij is, is uitsluitend het Nederlands recht van toepassing.
                  Partijen zullen eerst een beroep op de rechter doen nadat zij
                  zich tot het uiterste hebben ingespannen een geschil in
                  onderling overleg te beslechten.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-500">
                  11. Wijziging voorwaarden
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-501">
                  Blue Rain Productions is bevoegd wijzigingen in deze
                  voorwaarden aan te brengen. De wijzigingen treden in werking
                  op het aangekondigde tijdstip van inwerkingtreding.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-502">
                  Contact
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-503">
                  Als u vragen heeft over onze algemene voorwaarden, neem dan
                  contact met ons op via:
                </p>
                <p className="text-gray-300 mb-6" data-id="element-504">
                  E-mail: info@bluerainproductions.nl
                  <br data-id="element-505" />
                  Telefoon: +31651764541
                </p>
                <p className="text-gray-400 mt-10 text-sm" data-id="element-506">
                  Laatste update:{' '}
                  {new Date().toLocaleDateString('nl-NL', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-507" />
    </div>;
};